import { faMessage, faUser } from "@fortawesome/free-solid-svg-icons";
import { INDUCTION_HOME_ROUTE } from "@core/consts/assignment-page.constants";
import type { MobileSecondaryMenuItem } from "@core/models/mobile-secondary-menu-item.model";
import { SETTINGS_LINK_ACTIVE_OPTIONS } from "@core/consts/link-active-options.constants";

export const MOBILE_SECONDARY_MENU_INDUCTION_ITEM: MobileSecondaryMenuItem = {
  route: INDUCTION_HOME_ROUTE,
  navIcon: "induction",
  labelKey: "navbar.induction",
};

export const MOBILE_SECONDARY_MENU_ITEMS: readonly MobileSecondaryMenuItem[] = [
  {
    route: "/settings",
    icon: faUser,
    labelKey: "navbar.myProfile",
    linkActiveOptions: SETTINGS_LINK_ACTIVE_OPTIONS,
  },
  {
    route: "/help-forum",
    icon: faMessage,
    labelKey: "navbar.forum",
  },
];
